import gql from 'graphql-tag';
import seatPlanFragment from './seatPlanFragment.fragment.graphql.js';
import seatPriceFragment from '../seatsPage/seatPriceFragment.fragment.graphql.js';

export default gql`
  ${seatPlanFragment},
  ${seatPriceFragment}

  mutation seatSelect(
    $seatsSelection: [SeatSelectionInput!]!
    $activeLeg: Int
    ) {
    selectSeats(
      seatsSelection: $seatsSelection
      activeLeg: $activeLeg
      ) {
      order {
        price {
          total
        }
        items {
          id
          ... on SeatOrderItem {
            id
            travelerId
            flightId
            row
            column
            autoSelect
            price {
              amount
            }
            ...seatPriceFragment
            bundledAncillaryPrice {
              amount
            }
          }
          ... on FlightOrderItem {
            seatmap {
              # We use this fragment to update the seatplan as the result of other queries.
              ...seatPlanFragment
            }
          }
          ... on TravelerAncillaryOrderItem {
            ancillaryType
            isBundledAncillaryIncluded
            price {
              amount
              currency
              __typename
            }
            flightId  
            travelerId
            quantity
            __typename
          }  
        }
      }
      errors
    }
  }
`;
